Backbone.Radio.channel('views').reply('form-contacts',function(options){
	var opts = {
		
	};
	var phoneNumber = "";
	var phoneLookupResults = {};
	
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-contacts").html())
		,templateContext:function(){
			console.log('qs',Backbone.settings.qs)
			var fname = ""
				,mname = ""
				,lname = ""
				,street1 = ""
				,street2 = ""
				,city = ""
				,state = "VA"
				,zip = ""
				,email = ""
				,phone = "";
				
			if(Backbone.settings.qs.fname){ fname=Backbone.settings.qs.fname; }
			if(Backbone.settings.qs.mname){ mname=Backbone.settings.qs.middle; }
			if(Backbone.settings.qs.lname){ lname=Backbone.settings.qs.lname; }
			if(Backbone.settings.qs.streetnumber){ street1=Backbone.settings.qs.streetnumber; }
			if(Backbone.settings.qs.streetname){ street1 = (street1 +" "+Backbone.settings.qs.streetname).trim(); }
			if(Backbone.settings.qs.street2){ street2=Backbone.settings.qs.street2; }
			if(Backbone.settings.qs.city){ city=Backbone.settings.qs.city; }
			if(Backbone.settings.qs.zip){ zip=Backbone.settings.qs.zip; }
			if(Backbone.settings.qs.state){ state=Backbone.settings.qs.state.toUpperCase(); }
			if(Backbone.settings.qs.email){ email=Backbone.settings.qs.email; }
			if(Backbone.settings.qs.phone){ phone=Backbone.settings.qs.phone; }
			
			return {
				fname:fname
				,mname:mname
				,lname:lname
				,street1:street1
				,street2:street2
				,city:city
				,state:state
				,zip:zip
				,email:email
				,phone:phone
			}
		}
		,events:{
			'change .nameDropdown':function(e){
				if( $(e.currentTarget).val().toLowerCase() == 'other' ){ 
					$(e.currentTarget).next().show();
				}else{
					$(e.currentTarget).next().hide();
				}
			}
			,'click #btnAddMember':function(e){
				e.preventDefault();
				this.$el.find('#addMember').removeClass('d-none')
				$(e.currentTarget).hide()
			}
			,'click #btnRemoveMember':function(e){
				e.preventDefault();
				this.$el.find('#addMember').addClass('d-none')
				$('#btnAddMember').show()
			}
			,'blur.error #fname, #lname, #address, #city, #zip, #phone':function(e){
				var $this = $(e.currentTarget),
				    id = $this.attr('id');
		
				if( !$this.val().length ){
					$this.addClass('error'); 
					this.$el.find('#error-'+id).show() 
				}else{
					$this.removeClass('error'); 
					this.$el.find('#error-'+id).hide() 
				}
				
				if( id == 'zip' && ($this.val().replace(/[^0-9]/g, '').length != 5 && $this.val().replace(/[^0-9]/g, '').length != 9) ){ $this.addClass('error'); this.$el.find('#error-zip').show()  }
				
				if( id == 'phone' && ($this.val().replace(/[^0-9]/g, '').length != 10) ){ $this.addClass('error'); this.$el.find('#error-phone').show()  }
			}

		}
		,onAttach:function(){
			if(Backbone.settings.flags.pledgeDrive){
				this.$el.find('#currentMember').show();
			}
			if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){
				setupPhoneLookup();
			}
		}
	});
	
	function setupPhoneLookup(){
			//move things around
			$('#placeholder_phone').replaceWith(  $('#phoneContainer') )
			
			//assign event
			$('body').on('keyup','#phone',function(){
				var newPhone = $(this).val().replace(/[^0-9]/g, '');
				
				if(newPhone.length == 10 && newPhone != phoneNumber){
					phoneNumber = newPhone;
					lookupMembersByPhoneNumber()
				}	
			});
			
			$('body').on('click','#phoneResults button',function(e){
				e.preventDefault();
				
				resetPhoneLookup()
				
				var contactId = $(this).data('contact');
				var selectedAccount = "";
				//put up a spinner
				$('#phoneResults').empty().append('<div id="loaderMessage">Retrieving Account Record. Please wait...</div><div class="loader"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>').show()
	
				if(contactId != -1){ // -1 == 'None of these' 
					//Find this contact in the phoneResults we originally pulled back
					$.each(phoneLookupResults,function(index,hit){
						if(hit.account && hit.account.contacts && hit.account.contacts.length){
							$.each(hit.account.contacts,function(cindex,contact){
								if(contact.Id === contactId){ 
									selectedAccount = hit;
									return false; 
								}
							})
						}
						if(selectedAccount){ return false; /* return false is 'break', where return true is 'continue' */ }
					})
					//console.log('selectedAccount',selectedAccount)
					$('#phoneResults').slideUp().empty()
					$('#accountId').val( selectedAccount.AccountId )
					$('#contactId').val( selectedAccount.account.contacts[0].Id )
					$('#contactId2').val( (selectedAccount.account.contacts[1])?selectedAccount.account.contacts[1].Id:"" )
					
					// Are they an active sustainer?
					if(selectedAccount.account.contacts[0].Account.rC_Giving__Active_Sustainer__c){
						$('#curSustainer').val("true")
					}
					
					/*
					if(selectedAccount.opportunity && selectedAccount.opportunity[0] && selectedAccount.opportunity[0].rC_Giving__Is_Sustainer__c && +selectedAccount.opportunity[0].rC_Giving__Giving_Amount__c > 0){
						$('#opportunityId').val( selectedAccount.opportunity[0].Id );
						
						$('#volText_noSustainer').hide();
						$('#volText_curSustainerAmount').html(selectedAccount.opportunity[0].rC_Giving__Giving_Amount__c)
						$('#volText_curSustainer').show();
					}else{
						$('#opportunityId').val("");
						
						$('#volText_curSustainer').hide();
						$('#volText_noSustainer').show();
					}
					*/
					
					if(!selectedAccount.account.contacts[0].Salutation){ //no title
						$('#title option:first-child').prop('selected','selected');
					}else if( $('#title option').filter(function() { return $(this).text() == selectedAccount.account.contacts[0].Salutation; }).length ){
						$('#title option').filter(function() { return $(this).text() == selectedAccount.account.contacts[0].Salutation; }).prop('selected','selected')
						$('#title').trigger('change')
					}else{ //title doesn't match an existing option
						$('#title').val( 'OTHER' ).trigger('change').attr('data-text', selectedAccount.account.contacts[0].Salutation).attr('data-abbr', selectedAccount.account.contacts[0].title )
						$('#nameTitleInput').val( selectedAccount.account.contacts[0].Salutation )
					}
					$('#fname').val( selectedAccount.account.contacts[0].FirstName ).data('old-value',selectedAccount.account.contacts[0].FirstName)
					$('#mname').val( selectedAccount.account.contacts[0].rC_Bios__Middle_Name__c )
					$('#lname').val( selectedAccount.account.contacts[0].LastName )
	
					if(selectedAccount.account.contacts[1]){ //2nd member
						$('#btnAddMember').trigger('click')
	
						if(!selectedAccount.account.contacts[1].Salutation){ //no title
							$('#title2 option:first-child').prop('selected','selected');
						}else if( $('#title2 option').filter(function() { return $(this).text() == selectedAccount.account.contacts[1].Salutation; }).length ){
							$('#title2 option').filter(function() { return $(this).text() == selectedAccount.account.contacts[1].Salutation; }).prop('selected','selected')
							$('#title2').trigger('change')
						}else{ //doesn't match an existing option
							$('#title2').val( 'OTHER' ).trigger('change').attr('data-text', selectedAccount.account.contacts[1].Salutation).attr('data-abbr', selectedAccount.account.contacts[1].Salutation )
							$('#nameTitleInput2').val( selectedAccount.account.contacts[1].Salutation )
						}
					}else{
						$('#btnRemoveMember').trigger('click')
					}
	                
					//always set so things can be cleared if needed
					$('#fname2').val( (selectedAccount.account.contacts[1])?selectedAccount.account.contacts[1].FirstName:"" ).data('old-value',(selectedAccount.account.contacts[1])?selectedAccount.account.contacts[1].FirstName:"")
	                $('#mname2').val( (selectedAccount.account.contacts[1])?selectedAccount.account.contacts[1].rC_Bios__Middle_Name__c:"" )
	                $('#lname2').val( (selectedAccount.account.contacts[1])?selectedAccount.account.contacts[1].LastName:"" )
	    				
	                
	                $('#address').val( (selectedAccount.account.contacts[0] && selectedAccount.account.contacts[0].address)?selectedAccount.account.contacts[0].address.rC_Bios__Street_Line_1__c:"" )
	                $('#address2').val((selectedAccount.account.contacts[0] && selectedAccount.account.contacts[0].address)?selectedAccount.account.contacts[0].address.rC_Bios__Street_Line_2__c:"" )
	
	                $('#city').val(  (selectedAccount.account.contacts[0] && selectedAccount.account.contacts[0].address)?selectedAccount.account.contacts[0].address.rC_Bios__City__c:""        )
	                $('#state').val( (selectedAccount.account.contacts[0] && selectedAccount.account.contacts[0].address)?selectedAccount.account.contacts[0].address.rC_Bios__State__c:"VA"       )
	                $('#zip').val(   (selectedAccount.account.contacts[0] && selectedAccount.account.contacts[0].address)?selectedAccount.account.contacts[0].address.rC_Bios__Postal_Code__c:"" )
	
	                $('#email').val( (selectedAccount.account.contacts[0])?selectedAccount.account.contacts[0].Email:"" )
				}else{
	                //the else should be mostly covered by the reset this function starts off with
	                $('#phoneResults').slideUp()
	            }
			});
			
			$('body').on('click','#phoneResults .showMemberDetails',function(){
				$('#phoneResults').find('.ft').hide()
								  .end().find('.bd').slideDown();
			})

			/*
				There are times when a volunteer will mis-click and select a phone result they did not want. 
				In this case, they just change the filled in data to the correct person. But because they 
				chose a lookup result, we have recorded an account id, which causes what should be the new 
				account to be merged with the old one. 
				
				To fix this, track changes to the #fname field. If it changes, clear the account id.
			*/
			$('body').on('change',"#fname", function(){
				var $this = $(this);
				//console.log($this.data('old-value'))
				if($this.data('old-value')){
					//we no longer trust the data we have, so clear all the hidden stuff and the hide/show we did based on it
					resetPhoneLookup()
				}
				
				$this.data('old-value', $this.val() );
			});

			$('body').on('change',"#fname2", function(){
				var $this = $(this);
				if($this.data('old-value')){
					// Unlike Contact 1, we don't distrust the entire account matching if only contact 2 changed.
					$('#contactId2').val('');
				}
				$this.data('old-value', $this.val() );
			});
		
		}
		function lookupMembersByPhoneNumber(){
			//put up a spinner
			$('#phoneResults').empty()
				.append('<div id="loaderMessage">Retrieving Account Record. Please wait...</div><div class="loader"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>').show()
			
			var a = $.ajax({
				url : APP_CONFIG.SALESFORCE_API_ROOT+'lookup',
				dataType: 'json',
				data : {
					"sustainerinfo":true,
					"phone" : phoneNumber 
				}
			});
			
			a.done(function(results){
				var htm = '',
					optionalHtm = '',
					tmpContactIds = []; //this is just to check dupes against inside this function
				
				phoneNumber = "";
				phoneLookupResults = (results && results.hits>0 && results.hit)?results.hit:"";
				if(phoneLookupResults){
					//the 'none of those' button (moved to top in PT75988062)
					htm += "<div class='row result py2'><div class='col-md-4 offset-md-8'><div class='hd'><button class='btn btn-danger' data-contact='-1'>None of these.</button></div></div></div>";
					$.each(phoneLookupResults,function(index,hit){
						if(hit.account && hit.account.contacts && hit.account.contacts.length){
							$.each(hit.account.contacts,function(index,contact){
								//if two contacts have the same phonenumber on the same account, they will appear twice.
								//	This is because we show all account contacts when any match the number.
								//	So de-dupe here
								if( $.inArray( contact.Id, tmpContactIds ) != -1 ){
									return; //acts as 'continue;'
								}
								tmpContactIds.push(contact.Id);
								
								htm += "<div class='row result py2'>";
									htm += "<div class='col-md-8'>";
										htm += "<div class='hd font-bold'>";
											/* Bc undefined+" " == "undefined", we need to explicitly exclude this if it isn't there */
											if(contact.Salutation){
												htm += contact.Salutation +" ";
											}
											htm += contact.FirstName +" ";
											if(contact.rC_Bios__Middle_Name__c){
												htm += contact.rC_Bios__Middle_Name__c +" ";
											}
											htm += contact.LastName;
										htm += "</div>";
										htm += "<div class='bd'>";
										    //if(contact.address[0]){
			    							//	htm += contact.address[0].rC_Bios__Street_Line_1__c +"<br>";
			    							//	if(contact.address[0].rC_Bios__Street_Line_2__c){ htm += contact.address[0].rC_Bios__Street_Line_2__c+'<br>'; }
			    							//	htm += contact.address[0].rC_Bios__City__c +", "+contact.address[0].rC_Bios__State__c+" "+contact.address[0].rC_Bios__Postal_Code__c;
			                                //}
			                                if(contact.address){
			    								htm += contact.address.rC_Bios__Street_Line_1__c +"<br>";
			    								if(contact.address.rC_Bios__Street_Line_2__c){ htm += contact.address.rC_Bios__Street_Line_2__c+'<br>'; }
			    								htm += contact.address.rC_Bios__City__c +", "+contact.address.rC_Bios__State__c+" "+contact.address.rC_Bios__Postal_Code__c;
			                                }
											if(contact.Email){ htm += '<br>'+contact.Email; }
										htm += "</div>";
										htm += "<div class='ft'><span class='showMemberDetails fakeLink'>[Show Details]</span></div>";
									htm += "</div>";
									htm += "<div class='col-md-4'>";
										htm += "<button class='btn btn-success' data-contact='"+contact.Id+"'>Select</button>";
									htm += "</div>";
								htm += "</div>";
							})
						}
					})
					
					//wrap it all with some instructions
					if(phoneLookupResults.length > 1){ optionalHtm = "<em>If these names are too similar, click <span class='showMemberDetails fakeLink'>[Show Details]</span> and ask for their address.</em>"; }
					htm = "<div class='row'><div class='col-md-6 offset-md-4'><p class='volunteerText font-bold'>May I have your name?</p><p><em style='display:block;padding-top:4px'>Select the name they say or click 'None of these'.</em></p>" + optionalHtm + htm +"</div></div>";
				}else{
	    			htm = "<div style='text-align: center;font-weight: bold;margin: 1rem;'>No results found. Continue.</div>";
				}
				
				$('#accountId').val('')
				$('#contactId').val('')
				$('#contactId2').val('')
				$('#opportunityId').val('')
				$('#phoneResults').empty().append( htm ).slideDown()
				
			})
			
			a.fail(function(results){
				//console.log('ajax fail',results)
				$('#phoneResults').empty() //if the call fails, just clear things and pretend nothing happened
			})
	

	
		}
		
		/* Sometimes we just need to reset the lookup to be as if we didn't make any selection at all. */
		function resetPhoneLookup(){
			$('#curSustainer').val("")
			$('#accountId').val('')
			$('#contactId').val('')
			$('#contactId2').val('')
			$('#opportunityId').val('')
			$('#CHARGE_CARD_NUMBER').val('')
			$('#CHARGE_EXPIRE_DATE').val('')
			$('#CHARGE_CARD_ALIAS').val('')
			$('#PAYMENT_METHOD').val('')
			$('#BANK_ACCOUNT').val('')
			$('#BANK_ID').val('')
			$('#PULL_CYCLE').val('')
			$('#EFT_ALIAS').val('')
			
			$('#volText_noSustainer').show();
			$('#volText_curSustainer').hide();
			$('#giftsHeader').show()
			$('#gifts').show()
			//Payments
			$('.btnVolShowPaymentOptions').hide()
			$('#volText_curSustainerPayments').hide()
			$('#paymentsContainer').show()
			$('.volCurPaymentDetails').html("")
		}


	
	
	return new (view)();
});